module.exports = __webpack_public_path__ + "img/icon2.bf07e86c.png";